<template>
    <div class="card">
        <div class="container-fluid mt-1 mb-1">
            <form class="form-inline contct my-2 my-lg-0">
                <select class="form-control mr-sm-2 market_select" v-model="search.ward">
                    <option value="">মার্কেট সিলেক্ট করুন</option>
                    <option v-for=" ward in wards" :key="ward.id" :value="ward.id">{{ ward.name}}{{ ward.ward_name_bng}}</option>
                </select>
                <input v-model="search.account_no" class="form-control mr-sm-2" type="search" placeholder="Name / Account No" aria-label="Name / Account No">
                <button @click.prevent="searchApplication" class="btn btn-success my-2 my-sm-0" >Search</button>
            </form>
        </div>
        <div  class="container-fluid" style="overflow: auto;">
            <table id="my-table" class="table table-striped table_fields">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">নাম</th>
                        <th scope="col">হিসাব নাম্বার</th>
                        <th scope="col">মোবাইল</th>
                        <th scope="col">মার্কেট</th>
                        <th style="text-align:right" scope="col">মাসিক বিল</th>
                        <th scope="col">একশন</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(application,key) in allApplication.data" :key="key">
                        <td>{{key+1}}</td>
                        <td><span v-if="application.user">{{application.user.name}}</span></td>
                        <td>{{application.account_no}}<br></td>
                        <td>{{application.user.mobile_number}}</td>
                        <td><span v-if="application.market">{{application.market.name}}</span></td>
                        <td style="text-align:right"><span>{{application.price}} /-</span></td>
                        <td>
                            <i v-if="permission.market_leadge_update" @click="editApplication(application,key)" class="icon-note icons actn" style="vertical-align:middle; font-size:17px;"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :limit="5" :data="allApplication" @pagination-change-page="getResults"></pagination>
            </nav>
        </div>
        <editMalikanaModal ref="edit_application"></editMalikanaModal>
    </div>
</template>

<script>
import axios from "axios"
import pagination from 'laravel-vue-pagination'
import editMalikanaModal from '@/views/application/market/editMalikanaModal'
import { SEARCH_APPLICATION} from "@/store/action.type"
import { mapGetters } from "vuex"
export default {
    data(){
        return {
            loading:false,
            permission:'',

            search:{
                account_no:'',
                ward:''
            },
            user:{
                nid:'',
                mobile_number:''
            },
            type: 'new-market-leadge',
        }
    },
    methods:{
        editApplication(data,id){
            this.$refs.edit_application.openModal(data,id)
        },
        getResults(page = 1){
            var data = {type:'new-market-leadge', page:page}
            this.$store.dispatch('ALL_APPLICATION',data)
        },
        searchApplication(){
            this.loading = true;
            var data = this.search
            //console.log(data)
            var page = 1
            this.$store.dispatch('SEARCH_APPLICATION',{page,data})
            .then(response=>{
                this.loading=false;
            })
            .catch(error=>{
                this.loading=false;
            });
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },

    mounted(){
        this.getResults()
        this.allRole()
        this.getPermission()

        var invoice_type = 'market-billing';
        this.$store.dispatch('WARD_LIST',{invoice_type})
        //console.log(this.getResults())
    },
    computed: {
        ...mapGetters(['wards',"allApplication","user_roles"]),
    },
    components:{
       pagination,
       editMalikanaModal
    }
}
</script>


<style>
.breadcrumb{
    margin-bottom: 1rem;
}
.main .container-fluid{
    padding: 0 16px;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
.market_select{max-width: 200px;}
 @media (max-width: 575px){
    .contct-b{ width: 100% !important;}
    .market_select{ max-width: 100%; margin-bottom: 10px;}
    .contct{ padding-top: 0px;}
}
</style>
